import Service from "../../Service";

const resource = "HmnPublicRecruitmentContactEvent/";

export default {
  paginate(dtr, requestID) {
    return Service.post(resource + "paginate", dtr, {
      params: { requestID: requestID },
    });
  },
  list(requestID) {
    return Service.post(resource + "list", null, {
      params: { requestID: requestID },
    });
  },
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
};
